import * as React from "react";
import {Trans} from "react-i18next";
import {Link} from "gatsby-plugin-react-i18next";

interface DefaultHeaderProps {
	backgroundClass: string;
	title: string;
	breadcrumbs?: {
		title: string;
		path: string;
	}[];
}

const DefaultHeader: React.FC<DefaultHeaderProps> = (props) => {
	return (
		<div className={`w-full contact-bg ${props.backgroundClass}`}>
			<div className="max-w-6xl mx-auto px-6 py-28">
				<h1 className=" text-3xl md:text-5xl text-white uppercase text-center font-extrabold pb-3 md:pb-6">
					{props.title}
				</h1>
				<div className='flex justify-center'>
					<p className='text-white text-base capitalize text-center'>
						<Link to="/">
							<Trans>Home</Trans>
						</Link>
						{props.breadcrumbs && props.breadcrumbs.map((breadcrumb, idx) => {
							return (
								<React.Fragment key={idx}>
									<span className='text-red-700 text-lg px-1'>
										{">"}
									</span>
									<Link to={breadcrumb.path}>
										{breadcrumb.title}
									</Link>
								</React.Fragment>
							);
						})}
					</p>
				</div>
			</div>
		</div>
	);
};

export default DefaultHeader;
